import {theme} from "Theme";
import {DateUtil} from "base/format/utilities";
import {TextLink} from "base/navigation/components";
import {PermitTypeTags} from "permit/presentational";

import Tooltip from "@mui/material/Tooltip";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import HorizontalRuleOutlinedIcon from "@mui/icons-material/HorizontalRuleOutlined";

export function useApprovedPermitsTable() {
    const tableColumns = [
        {
            id: "code",
            label: "Código",
            width: 10,
            formatFunction: item => (
                <TextLink
                    text={item?.code}
                    to={`/permits/approved/list/${item.id}/summary`}
                    textStyle={{fontSize: "inherit"}}
                />
            ),
        },
        {
            id: "is_valid",
            label: "Em vigor",
            width: 5,
            formatFunction: item =>
                item.is_valid ? (
                    <Tooltip title="Em vigor">
                        <CheckCircleOutlinedIcon color="success" />
                    </Tooltip>
                ) : (
                    <Tooltip title="Vencida">
                        <CancelOutlinedIcon color="action" />
                    </Tooltip>
                ),
            align: "center",
        },
        {
            id: "has_extension",
            label: "Prorr.",
            width: 5,
            formatFunction: item => {
                return item.has_extension ? (
                    <Tooltip title="Prorrogada">
                        <MoreTimeIcon sx={{color: theme.palette.primary.main}} />
                    </Tooltip>
                ) : (
                    <HorizontalRuleOutlinedIcon color="action" />
                );
            },
            align: "center",
        },
        {
            id: "on_date",
            label: "Data de aprovação",
            width: 15,
            formatFunction: item => DateUtil.formatDate(item.on_date),
            align: "right",
        },
        {
            id: "holder__name",
            label: "Titular",
            width: 15,
            formatFunction: item => (
                <TextLink
                    text={item?.holder?.name}
                    to={`/holders/all/list/${item.holder?.id}/summary`}
                    textStyle={{fontSize: "inherit"}}
                />
            ),
        },
        {
            id: "district",
            label: "Distrito",
            width: 15,
        },
        {
            id: "plot__land_ownership",
            label: "Propriedade da terra",
            width: 15,
            formatFunction: item => {
                return item?.plot?.land_ownership;
            },
        },
        {
            id: "types",
            label: "Guias",
            width: 25,
            formatFunction: item => {
                return <PermitTypeTags types={item?.types} />;
            },
            disableSorting: true,
        },
    ];

    return {tableColumns};
}
